import React, { FC, useState } from 'react';
import { useParams } from 'react-router-dom';

import LocationSelect from 'Components/LocationSelect/LocationSelect';
import WizardWrap from 'Components/RequestWizard/WizardWrap';
import { isWindow } from 'common/helpers/helpers';

import { CitySuggestion } from '../LocationSelect/LocationSearch.helpers';
import './WizardLocation.scss';

type Props = {
  city?: CitySuggestion;
  neighbourhood?: {
    id: string;
    name: string;
    slug: string;
  };
};

const WizardLocation: FC<Props> = (props) => {
  const { slug } = useParams<{ slug: string }>();
  const [errorMessage, setErrorMessage] = useState<string>('');
  const [selectedCity, setSelectedCity] = useState<CitySuggestion | undefined>(undefined);

  const openWizard = (selectedSuggestion: CitySuggestion): void => {
    setSelectedCity(selectedSuggestion);
    setErrorMessage('');

    window.postMessage(
      {
        type: 'open-wizard',
      },
      window.location.origin
    );
  };

  const requestLocation = selectedCity && {
    lat: selectedCity.lat,
    lng: selectedCity.long,
  };

  return (
    <div className="wizardLocation">
      <LocationSelect
        /* @ts-expect-error type mismatch */
        city={props.city}
        neighbourhood={props.neighbourhood}
        onSubmit={openWizard}
        onError={() => setErrorMessage('Wpisz nazwę miejscowości')}
        onCityPrefilled={() => setErrorMessage('')}
        isError={Boolean(errorMessage)}
        errorMessage={errorMessage}
        isLocationAutodetect
      />
      {isWindow && (
        <WizardWrap
          cityId={selectedCity?.id}
          cityName={selectedCity?.name}
          requestLocation={requestLocation}
          categorySlug={slug}
          skipDistrictStep={selectedCity && !selectedCity.hasCityDistricts}
          neighbourhoodId={props.neighbourhood ? props.neighbourhood.id : undefined}
        />
      )}
    </div>
  );
};

export default WizardLocation;
